var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", { staticClass: "evaluation-table-row" }, [
    _c(
      "td",
      {
        staticClass:
          "typography--body-2 evaluation-table-td evaluation-table-student-number"
      },
      [_vm._v("\n    " + _vm._s(_vm.evaluation.number || "-") + "\n  ")]
    ),
    _vm._v(" "),
    _c(
      "td",
      {
        staticClass:
          "typography--body-2 evaluation-table-td evaluation-table-student-name"
      },
      [_vm._v("\n    " + _vm._s(_vm.evaluation.name) + "\n  ")]
    ),
    _vm._v(" "),
    _vm.evaluationComment && !_vm.loading
      ? _c(
          "td",
          {
            staticClass:
              "typography--body-2 evaluation-table-td evaluation-table-comment"
          },
          [
            _vm._v("\n    " + _vm._s(_vm.evaluationComment) + "\n\n    "),
            _c(
              "div",
              { staticClass: "evaluation-table-row-actions" },
              [
                _vm._l(_vm.domains, function(domain) {
                  return _c("EvaluationBadge", {
                    key: domain.id,
                    attrs: { domain: domain }
                  })
                }),
                _vm._v(" "),
                _c("button", {
                  directives: [
                    {
                      name: "clipboard",
                      rawName: "v-clipboard",
                      value: _vm.evaluationComment,
                      expression: "evaluationComment"
                    }
                  ],
                  staticClass:
                    "btn rounded-circle copy-evaluation-btn float-right",
                  attrs: {
                    title: _vm.$t("evaluations.table.btn.copied_to_clipboard")
                  },
                  on: {
                    success: function($event) {
                      return _vm.$root.$emit(
                        "show::snackbar",
                        _vm.snackbarOptions
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c("button", {
                  staticClass:
                    "btn rounded-circle refresh-evaluation-btn float-right mr-6",
                  attrs: { title: _vm.$t("evaluations.table.btn.refresh") },
                  on: {
                    click: function($event) {
                      return _vm.refreshEvaluation()
                    }
                  }
                })
              ],
              2
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.evaluationComment && !_vm.loading
      ? _c(
          "td",
          {
            staticClass:
              "typography--body-2 typography--color-disabled evaluation-table-td evaluation-table-comment"
          },
          [
            _vm.evaluationNotSupported
              ? _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("evaluations.table.comment_not_supported"))
                  )
                ])
              : _c("span", [
                  _vm._v(_vm._s(_vm.$t("evaluations.table.comment_empty")))
                ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.loading
      ? _c(
          "td",
          { staticClass: "evaluation-table-td evaluation-table-comment" },
          [_c("LoadingBounce", { staticClass: "float-left" })],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64ec101c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64ec101c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/evaluations/components/EvaluationTableRow.vue
// module id = OTO7
// module chunks = 1